import React from 'react';
import { Checkbox } from 'components/ui-kits/Form/Checkbox';
import DisplayText from 'components/ui-kits/DisplayText';
import { useForm } from 'react-hook-form';
import Stepper from 'components/Stepper';
import { Dialog } from 'components/Dialog';

type AcceptTermsFreePlanModalProps = {
  isClickNoThanks: boolean;
  isSpecialMerchant?: boolean;
  onClose: () => void;
  onAcceptSubmitted: () => Promise<void>;
};

export default function AcceptTermsFreePlanModal({
  isClickNoThanks,
  isSpecialMerchant,
  onClose,
  onAcceptSubmitted
}: AcceptTermsFreePlanModalProps) {
  const linkToShow = isClickNoThanks
    ? 'https://achil.com/web/cgv-free'
    : isSpecialMerchant
    ? 'https://achil.com/web/cgv-free-boulangerie'
    : 'https://achil.com/web/cgv-free-commercant';

  const { register, watch } = useForm({
    defaultValues: { acceptTerms: false }
  });
  const isAccepted = watch('acceptTerms');

  const onSubmit = async () => {
    await onAcceptSubmitted();
    onClose();
  };

  const step: React.ComponentPropsWithoutRef<typeof Stepper>['steps'] = [
    {
      id: 'first',
      header: 'Conditions générales de vente formule FREE',
      headerButtonConfig: {
        closeButton: {
          hideCloseButton: true
        }
      },
      content: (
        <>
          <DisplayText fontSize="M">
            Nous vous invitons à prendre connaissance des Conditions générales
            de vente de notre formule FREE en cliquant sur le lien ci-dessous :
          </DisplayText>
          <ul style={{ padding: '0 0 1.5rem 2rem' }}>
            <li
              style={{
                fontSize: '1.6rem',
                color: '#1976d2',
                margin: '2rem 0 0.5rem 2rem',
                textDecoration: 'underline'
              }}>
              <a
                href={linkToShow}
                rel="noreferrer"
                target="_blank"
                className="link">
                Consulter les Conditions générales de vente formule FREE
              </a>
            </li>
          </ul>
          <Checkbox
            fontSize="M"
            register={register}
            name="acceptTerms"
            id="acceptTerms">
            En cochant cette case, je confirme avoir lu et accepté les
            Conditions générales de vente formule FREE.
          </Checkbox>
        </>
      ),
      footerConfig: {
        previousButton: {
          label: 'Annuler',
          onClick: onClose
        },
        nextButton: {
          label: 'Envoyer',
          disabled: !isAccepted,
          onClick: onSubmit
        }
      }
    }
  ];

  return (
    <Dialog maxWidth="70rem" minWidth="70rem">
      <Stepper steps={step} />
    </Dialog>
  );
}
